import React from 'react';
import { Row } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import HeroCard from '../HeroCard/HeroCard';
import ResponseInformation from './ResponseInformation';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

function HeroCardResponse({
  reloadBotResponse,
  elem,
  showFav,
  /** Globle property id from redux */
  propertyId,
  selectedLang,
  historyUpdator,
  child,
  ishistory,
  viewResponse,
  isButtonShow
}) {
  return (
    <Row>
      <Colxx xxs="12" xs="3">
        {child === undefined && <ResponseInformation elem={elem} showFav={showFav} isRelicationResponse={false} selectedLang={selectedLang} historyUpdator={historyUpdator} />}
      </Colxx>
      <Colxx xxs="12" xs={child === undefined ? "9" : "12"}>
        <Row>
          <Colxx md="12" className="mb-2">
            <HeroCard
              code={elem.query.code}
              type={elem.response.type}
              messages={elem.response.messages}
              example={elem.response.example}
              link={elem.response.details.url}
              caption={elem.response.details.caption}
              numberOfMsg={elem.response.numberOfMsg}
              reloadBotResponse={reloadBotResponse}
              Title={elem.response.title}
              SubTitle={elem.response.subTitle}
              AllButtons={elem.query.buttons}
              SelectedButtons={elem.response.buttons}
              isEditAble={true}
              imageUrl={elem.response.imageUrl}
              cardlink={elem.response.link}
              selectedLang={selectedLang}
              historyUpdator={historyUpdator}
              isHistory={ishistory}
              isButtonShow={isButtonShow}
            />
          </Colxx>
        </Row>
      </Colxx>
    </Row>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps)(HeroCardResponse));
